var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSoundoff02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M12.931 2.849c.302.128.492.388.492.674v16.954c0 .28-.184.538-.478.668a1.03 1.03 0 0 1-.922-.05L4.454 16.65H1.391c-.492 0-.891-.337-.891-.754V8.1c0-.416.399-.753.891-.753h3.603l7.004-4.428c.27-.17.631-.198.933-.07m-1.29 2.178L5.824 8.704c-.154.097-.341.15-.534.15H2.282v6.288h2.451c.182 0 .36.047.509.135l6.399 3.759z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.569,
  d: "m23.339 9.301-5.548 5.549M17.791 9.17l5.548 5.548"
})));
export default SvgIconSoundoff02;